import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { en } from "./locales/en";
import { zh } from "./locales/zh";
import { ja } from "./locales/ja";
import { getUILanguageFromPersonalSettingCookie } from "./utils/personalSettingLanguage";

/**
 * 有登入 / 切換客戶後的 cookie 時，個人設定的 language 應優先於瀏覽器，避免整頁重載仍顯示成瀏覽器語系
 * 其餘：zh* → 中文、ja* → 日文、en* → 英文，其餘英文
 */
function getInitialLanguage() {
  const fromPersonalSetting = getUILanguageFromPersonalSettingCookie();
  if (fromPersonalSetting) return fromPersonalSetting;

  const browser =
    typeof navigator !== "undefined"
      ? (navigator.language || navigator.languages?.[0] || "")
      : "";
  const lower = browser.toLowerCase();
  if (lower.startsWith("zh")) return "zh";
  if (lower.startsWith("ja")) return "ja";
  if (lower.startsWith("en")) return "en";
  return "en";
}

const resources = {
  en: { translation: en },
  zh: { translation: zh },
  ja: { translation: ja },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  lng: getInitialLanguage(),
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
